<template>
  <transition name="appear">
    <div v-if="url" class="engage-video-mask">
      <div v-click-outside="handleClose" class="engage-video-container">
        <button
          data-external="engage-video-close-button"
          class="engage-video-close"
          @click="handleClose"
        >
          <FriedIcon :size="IconSize.Small" class="icon" icon="close" />
        </button>
        <VideoPlayer
          :url="url"
          :thumb-url="thumbUrl"
          :controls="true"
          :autoplay="true"
          @timeupdate="handleTimeUpdate"
          @pause="handlePause"
          @ended="handleEnded"
        />
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { IconSize } from '@getaccept/fried-tofu';
import { defineComponent, ref } from 'vue';
import VideoPlayer from './VideoPlayer.vue';

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'trackVideo'],
  setup(props, { emit }) {
    const currentVideoPlayTime = ref<number>(null);

    const handleClose = () => {
      sendTrackingData();
      emit('close');
    };

    const handleTimeUpdate = (playtime: number) => {
      currentVideoPlayTime.value = playtime;
    };

    const handlePause = () => {
      sendTrackingData();
    };

    const handleEnded = () => {
      sendTrackingData();
    };

    const sendTrackingData = () => {
      if (!currentVideoPlayTime.value) {
        return;
      }
      emit('trackVideo', { id: props.id, viewDuration: currentVideoPlayTime.value });
      currentVideoPlayTime.value = null;
    };

    return {
      IconSize,
      currentVideoPlayTime,
      handleClose,
      handleTimeUpdate,
      handlePause,
      handleEnded,
      sendTrackingData,
    };
  },
});
</script>
<style lang="scss" scoped>
.engage-video-mask {
  position: fixed;
  z-index: $z-modal;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000, 0.55);
  transition: opacity 0.3s ease;

  .engage-video-container {
    position: absolute;
    background-color: transparent;
    width: 90%;
    max-width: var(--page-width);
    min-width: 20rem;
    border-radius: var(--radius-small);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;

    .engage-video-close {
      z-index: $z-base;
      cursor: pointer;
      position: absolute;
      right: -0.75rem;
      top: -0.75rem;
      padding: var(--spacing-25);
      border-radius: 50%;
      height: 1.5rem;
      width: 1.5rem;
      border: 0;
      background: var(--gray-96);

      svg {
        padding: var(--spacing-25);
      }

      &:hover {
        background: var(--gray-89);
      }
    }

    :deep(.video-player-container) {
      z-index: $z-base;

      video {
        max-height: 75vh;
      }

      .video-html5 {
        box-shadow: var(--shadow-2);
      }
    }
  }
}
</style>
